module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_f_piebald.c0a3458a.png";